import TalkChannelPartner from "./images/talk-channel-partner.png";
import NegotiatePrice from "./images/negotiate-price.png";
import Documentation  from "./images/documentation.png";

export const FRANCHISE_STEPS = [
    {
        title: "Close the offer",
        desc: "Accept the offered price by the CARS24 Franchise Partner",
        icon: TalkChannelPartner
    },
    {
        title: "Complete the documentation",
        desc: "Provide key documents & bank account details for verification",
        icon: NegotiatePrice
    },
    {
        title: "Final payment & car pickup",
        desc: "Receive delivery payment and handover the car keys",
        icon: Documentation
    }
];

export const FRANCHISE_BOUGHT_STATUS = {
    IN_NEGOTIATION: "IN_NEGOTIATION",
    PRICE_CONSENT_ACCEPTED: "PRICE_CONSENT_ACCEPTED",
    PRICE_CONSENT_REJECTED: "PRICE_CONSENT_REJECTED",
    CAR_SOLD: "CAR_SOLD"
};
